export default "/_next/static/assets/fonts/SourceSansPro-Bold.639c2738552a0376c91e7d485e476fda.woff2";